import Axios from "axios";
import Vue, { CreateElement } from "vue";
import Router from "./router";
import Store from "./store"
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "bootstrap";
import BootstrapVue from "bootstrap-vue";
import VueMask from "v-mask";
import Toaster from "v-toaster";
import SweetAlert from "vue-sweetalert2";
import App from "./App.vue";

import "./scss/style.scss";

library.add(fas, fab, far);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueMask);
Vue.use(SweetAlert);
Vue.use(Toaster, {timeout: 5000});
Vue.use(BootstrapVue);

Vue.config.productionTip = true;

let axiosStatic = Axios.create({ baseURL: "/SolidWaste/" });
Vue.prototype.$http = axiosStatic;
export const axios = axiosStatic;

let options: any = {
	el: "#app",
	router: Router,
	// ReSharper disable once TsResolvedFromInaccessibleModule
	store: Store,
	render: (h: CreateElement) => h(App)
};

export const appVue = new Vue(options);